export class HttpError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
    this.name = "HttpError";

    // This is necessary for instanceof to work properly with TypeScript/ES6 classes
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}
